import { render, staticRenderFns } from "./cModalConclusiones.vue?vue&type=template&id=ac804678"
import script from "./cModalConclusiones.vue?vue&type=script&lang=js"
export * from "./cModalConclusiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports